import axiosInstance from "./AxiosConfig";
import endpoints from "./endpoints";

export const referralService = {
  listReferrals: (params = {}) => {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    
    const url = queryParams.toString() 
      ? `${endpoints.tokenEndPoints.listReferrals}?${queryParams.toString()}`
      : endpoints.tokenEndPoints.listReferrals;
    
    return axiosInstance.get(url);
  },

  getReferralDetailsByUserId: (userId) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.getReferralDetailsByUserId}/${userId}`),

  getReferralSummary: () =>
    axiosInstance.get(endpoints.tokenEndPoints.getReferralSummary),

  updateReferralStatus: (userId, status) =>
    axiosInstance.put(`${endpoints.tokenEndPoints.updateReferralStatus}/${userId}/status`, { status }),

  getReferralTracking: (params = {}) => {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.referrerId) queryParams.append('referrerId', params.referrerId);
    if (params.status) queryParams.append('status', params.status);
    
    const url = queryParams.toString() 
      ? `${endpoints.tokenEndPoints.getReferralTracking}?${queryParams.toString()}`
      : endpoints.tokenEndPoints.getReferralTracking;
    
    return axiosInstance.get(url);
  }
};